<mat-dialog-actions
    class="grid! h-auto! min-h-0! grid-cols-1! justify-stretch! gap-4! px-4! md:px-8! pb-6! pt-0! border-none!"
>
    <div class="benefits text-muted">
        @for (summary of summaries; track summary.header) {
            <div class="benefit">
                <qpx-hero-icon
                    class="shrink-0"
                    size="md"
                    [name]="summary.icon"
                    [context]="summary.context"
                />
                <p>
                    <span
                        class="benefit-title block font-semibold text-foreground"
                    >
                        {{ summary.header }}
                    </span>
                    <span class="block text-xs">{{ summary.subtitle }}</span>
                </p>
            </div>
        }
    </div>

    <button
        qpxButton
        matButton="filled"
        context="primary"
        class="min-h-12! w-full! max-w-none! justify-between!"
        [disabled]="!canContinue()"
        (click)="continueToCheckout.emit()"
    >
        <ng-icon
            qpx
            name="lucideLock"
            [strokeWidth]="2.5"
            matButtonIcon
            iconPositionStart
        />
        <span>{{ checkoutLabel() }}</span>
        <ng-icon
            qpx
            name="lucideArrowRight"
            [strokeWidth]="2.5"
            matButtonIcon
            iconPositionEnd
        />
    </button>

    <p class="flex justify-center items-center gap-1">
        <ng-icon
            qpx
            size="sm"
            name="lucideShieldCheck"
            context="success"
            [strokeWidth]="2.5"
        />
        <span class="text-xs font-semibold text-success-decorative"
            >Cancel or change plans anytime</span
        >
    </p>
</mat-dialog-actions>
